import '@popperjs/core/lib/popper.js'
import "bootstrap-icons/font/bootstrap-icons.css"
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import { createApp, nextTick } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Cookies from 'js-cookie';
import * as navbar from "@/services/navbar.service"

window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.interceptors.request.use(
    config => {
        if (Cookies.get('system')) {
            config.headers.authorization = `Bearer ${Cookies.get('system')}`;
        }
        return config;
    }, error => {
        return Promise.reject(error);
    });

axios.interceptors.response.use(response => {
    return response;
}, error => {
    // Go back to login page when not authenticated
    if (error.response.status === 401) {
        if (window.location.pathname != '/login' && window.location.pathname != '/') {
            Cookies.remove("system");
            window.location.href = "/";
        }
    }
    else if (error.response.status === 403) {
        alert("You don`t have permission to perform this action.");
    }
    return Promise.reject(error);
});

router.afterEach(async (to) => {
    await nextTick();
    const path = to.path.startsWith('/') ? to.path.slice(1) : to.path;
    if (path.startsWith('main')) {
        navbar.init(to.path);
    }
});

createApp(App).use(router).mount('#app')
